import React from "react";
import { motion } from "framer-motion";
import { PORTFOLIO } from "@/constants/testIds";

const cases = [
  {
    slug: "d2c-skincare",
    industry: "D2C · Skincare",
    title: "Scaled a skincare brand from ₹2L to ₹28L/mo via Meta Ads",
    metric: "+1300%",
    metricLabel: "Revenue Growth",
    detail: "Rebuilt the funnel, refreshed creatives weekly, locked in a 3.8 ROAS.",
  },
  {
    slug: "saas-leadgen",
    industry: "B2B SaaS",
    title: "Built an SEO + content engine for a SaaS startup",
    metric: "+140%",
    metricLabel: "Qualified Leads",
    detail: "20 SEO pages, 4 pillar guides, 6 link assets — organic became their #1 channel.",
  },
  {
    slug: "local-clinic",
    industry: "Healthcare · Local",
    title: "Local SEO + Google Ads for a multi-location clinic",
    metric: "₹12 → ₹4",
    metricLabel: "Cost / Lead",
    detail: "GMB optimization, location pages, and tight ad geo-targeting did the work.",
  },
  {
    slug: "fashion-launch",
    industry: "D2C · Apparel",
    title: "Launch campaign for a fashion brand",
    metric: "92K",
    metricLabel: "Followers in 90 days",
    detail: "Founder-led content + paid social + creator collabs drove the launch.",
  },
];

export const Portfolio = () => {
  return (
    <section
      id="work"
      data-testid={PORTFOLIO.section}
      className="relative py-24 lg:py-40 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 lg:mb-24">
          <div className="lg:col-span-3">
            <div className="flex items-center gap-2 mb-4">
              <span className="inline-block h-2 w-2 bg-zinc-900" />
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
                Selected Work
              </span>
            </div>
            <p className="text-sm text-zinc-500">03 / 06</p>
          </div>
          <div className="lg:col-span-9">
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] text-zinc-900">
              Case studies that
              <br />
              <span className="text-zinc-400">moved the needle.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-zinc-200 border border-zinc-200">
          {cases.map((c, idx) => (
            <motion.article
              key={c.slug}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: idx * 0.07 }}
              data-testid={PORTFOLIO.card(c.slug)}
              className="group bg-white p-8 lg:p-12 hover:bg-[#F4F4F5] transition-colors cursor-pointer"
            >
              <div className="flex items-start justify-between mb-12">
                <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
                  {c.industry}
                </span>
                <span className="text-xs text-zinc-400">0{idx + 1}</span>
              </div>

              <div className="font-display text-6xl lg:text-7xl text-[#002FA7] tracking-tighter leading-none">
                {c.metric}
              </div>
              <p className="mt-2 text-xs font-bold uppercase tracking-widest text-zinc-500">
                {c.metricLabel}
              </p>

              <h3 className="mt-10 font-display text-2xl lg:text-3xl tracking-tight leading-tight text-zinc-900">
                {c.title}
              </h3>
              <p className="mt-4 text-base text-zinc-600 leading-relaxed max-w-md">
                {c.detail}
              </p>

              <div className="mt-10 inline-flex items-center gap-2 text-sm font-bold text-zinc-900">
                <span className="border-b border-zinc-900 group-hover:border-[#002FA7] group-hover:text-[#002FA7] transition-colors">
                  Read the breakdown
                </span>
                <span className="group-hover:translate-x-1 transition-transform">→</span>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
